module.exports = __webpack_public_path__ + "images/exclude-notifications-a9df2ccd.svg";